/**
 * ecs-disclosure.ts — ECS Progressive Disclosure Mapping
 *
 * Maps UXMode → sovereign-facing disclosure levels for the
 * Executive Command Surface. Additive file — does NOT modify
 * progressive-disclosure.ts.
 *
 * Constitutional Basis:
 * - H-AX-02 (Clarity): Level names are sovereign-facing (Summary/Analysis/Forensic)
 * - H-AX-01 (Individual Primacy): Sovereign controls their disclosure level
 *
 * SN-IMPL-ECS-001-P0 Step 0.6
 */

import type { UXMode } from '@/types/ux-mode';

export type ECSDisclosureLevel = 'summary' | 'analysis' | 'forensic';

export const UX_MODE_TO_ECS_LEVEL: Record<UXMode, ECSDisclosureLevel> = {
  NOVICE: 'summary',
  INTERMEDIATE: 'analysis',
  EXPERT: 'forensic',
};

export function getECSDisclosureLevel(mode: UXMode): ECSDisclosureLevel {
  return UX_MODE_TO_ECS_LEVEL[mode];
}
